import {useContext, useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import {useReducedMotion, motion} from 'framer-motion';
import InvoiceInfo from '../InvoiceInfo/InvoiceInfo';
import {invoiceViewVariants} from '../../utilities/framerVariants';
import styles from './InvoiceView.module.scss';
import {AppContext} from "../../context/AppContext";
import Icon from "../elements/Icon/Icon";
import Status from "../elements/Status/Status";
import Button from "../elements/Button/Button";
import Spinner from "../elements/Spinner/Spinner";
import {useDispatch, useSelector} from "react-redux";
import {fetchInvoice} from "../../store/actions/invoicesActions";
import {toggleModal} from "../../store/actions/modalActions";

const InvoiceView = () => {
    const dispatch = useDispatch();
    const {id} = useParams();
    const invoice = useSelector((state) => state.invoices.currentInvoice);
    const isFetching = useSelector((state) => state.invoices.loading);
    const {windowWidth, setIsFormOpen, setIsInvoiceEdited, setEditedInvoice, isAdmin} = useContext(AppContext);
    const isDesktop = windowWidth >= 768;
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? invoiceViewVariants.reduced
            : invoiceViewVariants[element];
    };

    const handleEditInvoice = () => {
        setIsFormOpen(true);
        setIsInvoiceEdited(true);
        setEditedInvoice(invoice);
    }

    const handleChangeStatus = () => {
        dispatch(toggleModal('status'));
    }

    const handleDeleteInvoice = () => {
        dispatch(toggleModal('delete'));
    }

    useEffect(() => {
        if (id) {
            console.log('fetching invoice');
            dispatch(fetchInvoice(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (invoice) {
            document.title = `Invoices | # ${invoice.number}`;
        }
    }, [invoice]);

    if (isFetching || !invoice) {
        return <Spinner />;
    }

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <Link
                    className={styles.goBack}
                    to="/"
                    variants={variant('link')}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <Icon name={'arrow-left'} size={10}/>
                    Go back
                </Link>
                <motion.div
                    className={styles.controller}
                    variants={variant('controller')}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <p className={styles.label}>Status</p>
                    <Status currStatus={invoice.status}/>
                    {invoice.status === 'paid' && invoice.paidAt && (
                        <p className={styles.paidAt}>
                            Paid At: {new Date(invoice.paidAt).toLocaleDateString()} {new Date(invoice.paidAt).toLocaleTimeString()}
                        </p>
                    )}
                    {isDesktop && (
                        <div className={styles.buttonContainer}>
                            {invoice && invoice.status === 'draft' && invoice.isDraft && !isAdmin && (
                                <>
                                    <Button
                                        className='secondary'
                                        onClick={handleEditInvoice}
                                    >
                                        Edit
                                    </Button>

                                    <Button
                                        className='delete'
                                        onClick={handleDeleteInvoice}
                                    >
                                        Delete
                                    </Button>
                                </>
                            )}
                            {invoice && invoice.status !== 'paid' && invoice.status !== 'draft' && isAdmin && (
                                <Button
                                    className='primary'
                                    onClick={handleChangeStatus}
                                >
                                    Mark as Paid
                                </Button>
                            )}
                        </div>
                    )}
                </motion.div>
                <InvoiceInfo invoice={invoice}/>
            </div>
            {!isDesktop && (
                <div className={styles.buttonContainer}>
                    {invoice && invoice.status === 'draft' && invoice.isDraft && !isAdmin && (
                        <>
                            <Button className='secondary' onClick={handleEditInvoice}>
                                Edit
                            </Button>

                            <Button className='delete' onClick={handleDeleteInvoice}>
                                Delete
                            </Button>
                        </>
                    )}
                    {invoice && invoice.status !== 'paid' && invoice.status !== 'draft' && isAdmin && (
                        <Button
                            className='primary'
                            onClick={handleChangeStatus}
                        >
                            Mark as Paid
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default InvoiceView;
